import React from 'react';
import { styled } from '@mui/material';
import { Title } from './Title';
import { CountBubble } from './CountBubble';

interface SectionHeaderProps {
    title: string;
    count?: number;
}

export function SectionHeader({ title, count }: SectionHeaderProps) {
    return (
        <Header>
            <Title size="h2">{title}</Title>
            {count !== undefined && <CountBubble count={count} />}
        </Header>
    );
}

const Header = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
});
